import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import * as $ from "jquery";
declare var $: any;
@Component({
  selector: 'app-service-menu-home',
  templateUrl: './service-menu-home.component.html',
  styleUrls: ['./service-menu-home.component.scss']
})
export class ServiceMenuHomeComponent implements OnInit {

  constructor(public LANG:CommonUtilitiesService) { }

  ngOnInit() {
    this.initOwlCarouselProperties();
  }

  initOwlCarouselProperties() {
    $("#owlCarouselServices").owlCarousel({
      nav: false,
      dots: true,
      loop: false,
      rewind: true,
      margin: 30,
      autoplay: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        630: {
          items: 2
        },
        991: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  }
}
